enum PaymentMethod {
  Sepa = 'sepa',
  Card = 'card',
  Cash = 'cash'
}

export default PaymentMethod
